'use strict'

import { isBetaResourcesFolder } from '../../functions';
import { BmbyMode } from '../mode/BmbyMode';

export const analytics = (type, data) => {
    if (!config.features.googleAnalytics?.active ||
        isBetaResourcesFolder() || BmbyMode.active ||
        window.location.href.match('localhost:3100')) return;

    switch (type) {
        case 'option card': handleOptionCard(data); break;
        case 'unit card': handleUnitCard(data); break;
        case 'favorites': handleFavorites(data); break;
        case 'page_entrance': handlePageEntrance(data); break;
        case 'prepayment': handlePrepayment(data); break;
        case 'orientation': handleOrientation(data); break;
        case 'plan_paint': handlePaint2D(data); break;
        case 'floor_plan_paint': handleFloorPaint2D(data); break;
    }
}

function handlePaint2D (data) {
    gtag('event', 'plan_paint', {
        'bmbyPropID': data.bmbyPropID,
        'buildingEngineId': data.buildingEngineId,
        'buildingName': data.buildingName,
        'propNum': data.propNum,
        'floor': data.floorNum,
        'roomsCnt': data.roomNum,
        'cardViewDomain': window.location.hostname,
        'price': data.salePrice,
        'apartmentType': data.modelName,
        'domain': window.location.hostname
    });
}

function handleFloorPaint2D (data) {
    gtag('event', 'floor_plan_paint', {
        'buildingEngineId': data.buildingEngineId,
        'buildingName': data.buildingName,
        'floor': data.floorNum,
        'cardViewDomain': window.location.hostname,
        'domain': window.location.hostname
    });
}

function handleUnitCard (data) {
    gtag('event', 'card_preview', {
        'bmbyPropID': data.bmbyPropID,
        'buildingEngineId': data.buildingEngineId,
        'buildingName': data.buildingName,
        'propNum': data.propNum,
        'floor': data.floor,
        'roomsCnt': data.infoPoints ? data.infoPoints.roomNum : data.roomNum,
        'price': data.price,
        'apartmentType': data.infoPoints ? data.infoPoints.modelName : data.modelName,
        'cardViewDomain': window.location.hostname,
        'domain': window.location.hostname
    });
}

function handleOptionCard(data) {
    gtag('event', 'card_view', {
        'bmbyPropID': data.bmbyPropID,
        'buildingEngineId': data.buildingEngineId,
        'buildingName': data.buildingName,
        'propNum': data.propNum,
        'floor': data.floorNum,
        'roomsCnt': data.roomNum,
        'cardViewDomain': window.location.hostname,
        'price': data.salePrice,
        'apartmentType': data.modelName,
        'domain': window.location.hostname
    });
}

function handleFavorites(data) {
    if (!data.storageData) {
        gtag('event', 'favorite_added', {
            'addFavoritesBmbyPropID': data.crmDataOfFlat.bmbyPropID,
            'bmbyPropID': data.crmDataOfFlat.bmbyPropID,
            'buildingEngineId': data.crmDataOfFlat.buildingEngineId,
            'buildingName': data.crmDataOfFlat.buildingName,
            'addFavoritesPropNum': data.crmDataOfFlat.propNum,
            'addFavoritesCount': 1,
            'propNum': data.crmDataOfFlat.propNum,
            'floor': data.crmDataOfFlat.floorNum,
            'roomsCnt': data.crmDataOfFlat.roomNum,
            'price': data.crmDataOfFlat.salePrice,
            'apartmentType': data.crmDataOfFlat.modelName,
            'addFavoritesDomain': window.location.hostname,
            'domain': window.location.hostname
        });

        return;
    }

    gtag('event', 'favorite_removed', {
        'removeFavoritesBmbyPropID': data.crmDataOfFlat.bmbyPropID,
        'bmbyPropID': data.crmDataOfFlat.bmbyPropID,
        'buildingEngineId': data.crmDataOfFlat.buildingEngineId,
        'buildingName': data.crmDataOfFlat.buildingName,
        'removeFavoritesPropNum': data.crmDataOfFlat.propNum,
        'removeFavoritesCount': 1,
        'propNum': data.crmDataOfFlat.propNum,
        'floor': data.crmDataOfFlat.floorNum,
        'roomsCnt': data.crmDataOfFlat.roomNum,
        'price': data.crmDataOfFlat.salePrice,
        'apartmentType': data.crmDataOfFlat.modelName,
        'removeFavoritesDomain': window.location.hostname,
        'domain': window.location.hostname
    });
}

function handlePageEntrance (data) {
    gtag('event', 'page_entrance', {
        'page': data,
        'domain': window.location.hostname
    });
}

function handlePrepayment (data) {
    gtag('event', 'prepayment', {
        'bmbyPropID': data.bmbyPropID,
        'buildingEngineId': data?.buildingEngineId,
        'buildingName': data?.buildingName,
        'domain': window.location.hostname
    });
}

function handleOrientation(data) {
    gtag('event', 'orientation', {
        'orientation': data
    });
}
